// Retrieve borrowers
export const GET_BORROWERS_START = 'GET_BORROWERS_START';
export const GET_BORROWERS_SUCCESS = 'GET_BORROWERS_SUCCESS';
export const GET_BORROWERS_FAILURE = 'GET_BORROWERS_FAILURE';

// Retrieve funding organinzation
export const GET_FUNDING_ORG_START = 'GET_FUNDING_ORG_START';
export const GET_FUNDING_ORG_SUCCESS = 'GET_FUNDING_ORG_SUCCESS';
export const GET_FUNDING_ORG_FAILURE = 'GET_FUNDING_ORG_FAILURE';

// Retrieve agencies
export const GET_AGENCIES_START = 'GET_AGENCIES_START';
export const GET_AGENCIES_SUCCESS = 'GET_AGENCIES_SUCCESS';
export const GET_AGENCIES_FAILURE = 'GET_AGENCIES_FAILURE';

// Retrieve cost
export const GET_CURRENCIES_START = 'GET_CURRENCIES_START';
export const GET_CURRENCIES_SUCCESS = 'GET_CURRENCIES_SUCCESS';
export const GET_CURRENCIES_FAILURE = 'GET_CURRENCIES_FAILURE';

// Create Project 
export const CREATE_TOTAL_COST_START = 'CREATE_TOTAL_COST_START';
export const CREATE_TOTAL_COST_SUCCESS = 'CREATE_TOTAL_COST_SUCCESS';
export const CREATE_TOTAL_COST_FAILURE = 'CREATE_TOTAL_COST_FAILURE';

// Create Project 
export const CREATE_COMMITMENT_COST_START = 'CREATE_COMMITMENT_COST_START';
export const CREATE_COMMITMENT_COST_SUCCESS = 'CREATE_COMMITMENT_COST_SUCCESS';
export const CREATE_COMMITMENT_COST_FAILURE = 'CREATE_COMMITMENT_COST_FAILURE';

// Create Project details
export const CREATE_PROJECT_DETAILS_START = 'CREATE_PROJECT_DETAILS_START';
export const CREATE_PROJECT_DETAILS_SUCCESS = 'CREATE_PROJECT_DETAILS_SUCCESS';
export const CREATE_PROJECT_DETAILS_FAILURE = 'CREATE_PROJECT_DETAILS_FAILURE';
